import React from 'react'
import JobIcon from '../../../../JobElement/images/JobIcon'

function Stellenanzeigen(props) {
  return <JobIcon {...props} />
}

export default Stellenanzeigen
